export function isJSON(message: string) {
  try {
    JSON.parse(message)
    return true
  } catch {
    return false
  }
}
